import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=617ede1a&"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js&"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js&"
import style0 from "./RequiredDocuments.vue?vue&type=style&index=0&id=617ede1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports